import SegmentSingle from './SegmentSingle';
export default SegmentSingle;
